import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  FormInput,
  FormTextarea,
  Button,
  Row,
  Col,
  Container,
  FormFeedback,
  FormCheckbox,
} from "shards-react";

import dayjs from "dayjs";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import { useFormik } from "formik";

import MenuBar from "shared/components/MenuBar/MenuBar";
import Layout from "shared/container/Layout";
import useToken from "shared/hook/useToken";
import useCurrentUser from "shared/hook/useCurrentUser";
import {
  SelectagencyType,
  SelectAgency,
  SelectTypeUser,
} from "shared/components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ModalAddPermission } from "views/AdminUser/components";
import baseUrl from "config/baseUrl";

const axios = require("axios").default;

const UserProfilePage = styled.div`
  height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
`;
const UserProfileFooter = styled.div`
  padding: 30px 0;
  border-top: 1px solid #e0e0e0;
`;
const Link = styled.a`
  color: ${(props) => props.color || "#000"};
  display: block;
  cursor: pointer;
  :hover {
    color: ${(props) => props.color || "#000"};
    text-decoration: none;
  }
`;
const AdminUserDetail = (props) => {
  const { location } = props;
  const { match } = props;
  const { token } = useToken();
  const { curruntUser } = useCurrentUser();
  const [changePassword, setChangePassword] = useState(false);
  const [userDetail, setUerDetail] = useState(null);
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [userTypeId, setUserTypeId] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [agencyTypeId, setAgencyTypeId] = useState("");
  const [agencyId, setAgencyId] = useState("");
  const [positionName, setPositionName] = useState("");
  const [agencyType, setAgencyType] = useState("");
  const [agencyName, setAgencyName] = useState("");
  const [purposeAccessingSystem, setPurposeAccessingSystem] = useState("");
  const [userId, setUserId] = useState(match.params.id);
  const [loading, setLoading] = useState(false);
  const [dataindicatorsDataset, setDataindicatorsDataset] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [openModalAddPermission, setOpenModalAddPermission] = useState(false);
  const [indicatorsData, setIndicatorsData] = useState(null);
  const [userStatus, setUserStatus] = useState(1);

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = "กรุณาระบุชื่อผู้ใช้งาน";
    }
    if (!values.password && changePassword) {
      errors.password = "กรุณาระบุรหัสผ่าน";
    }
    if (!values.confirmpassword && changePassword) {
      errors.confirmpassword = "กรุณาระบุยืนยันรหัสผ่าน";
    } else if (values.password !== values.confirmpassword && changePassword) {
      errors.confirmpassword = "รหัสผ่านไม่ตรงกัน";
    }
    if (!values.firstName) {
      errors.firstName = "กรุณาระบุชื่อ";
    }
    if (!values.lastName) {
      errors.lastName = "กรุณาระบุนามสกุล";
    }
    if (!values.email) {
      errors.email = "กรุณาระบุอีเมล";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (!values.phone) {
      errors.phone = "กรุณาระบุเบอร์ติดต่อ";
    } else if (values.phone.length < 10) {
      errors.phone = "กรุณาระบุเบอร์ติดต่อให้ถูกต้อง";
    }
    if (!values.agencyId) {
      errors.agencyId = "กรุณาระบุชื่อหน่วยงาน";
    } else if (values.agencyId === "0") {
      errors.agencyId = "กรุณาระบุชื่อหน่วยงาน";
    }
    if (values.agencyId === "32" && !values.agencyName) {
      errors.agencyName = "กรุณาระบุชื่อหน่วยงาน";
    }
    // if (!values.positionName) {
    //   errors.positionName = "กรุณาระบุตำแหน่ง";
    // }
    if (!values.agencyTypeId) {
      errors.agencyTypeId = "กรุณารเลือกประเภทหน่วยงานของท่าน";
    } else if (values.agencyTypeId === "0") {
      errors.agencyTypeId = "กรุณารเลือกประเภทหน่วยงานของท่าน";
    }
    if (!values.userType) {
      errors.userType = "กรุณารเลือกประเภทผู้ใช้งาน";
    }
    return errors;
  };

  useEffect(() => {
    if (token && userId) {
      var data = JSON.stringify({
        params: {
          userId: userId,
        },
        show: 1,
        page: 1,
        orderBy: "userId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/users`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setUerDetail(response.data.users);
          setUserId(response.data.users[0].userId);
          setUsername(response.data.users[0].username);
          setName(response.data.users[0].username);
          setPassword(response.data.users[0].password);
          setFirstName(response.data.users[0].firstName);
          setLastName(response.data.users[0].lastName);
          setEmail(response.data.users[0].email);
          setPhone(response.data.users[0].phone);
          setAgencyTypeId(response.data.users[0].agencyTypeId);
          setAgencyId(response.data.users[0].agencyId);
          setPositionName(response.data.users[0].positionName);
          setAgencyType(response.data.users[0].agencyType);
          setAgencyName(response.data.users[0].agencyName);
          setUserTypeId(response.data.users[0].userType);
          setUserStatus(response.data.users[0].userStatus);
          setPurposeAccessingSystem(
            response.data.users[0].purposeAccessingSystem
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: username,
      // password: password,
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      agencyTypeId: agencyTypeId,
      agencyId: agencyId,
      positionName: positionName,
      agencyType: agencyType,
      agencyName: agencyName,
      userType: userTypeId,
      purposeAccessingSystem: purposeAccessingSystem,
      userStatus: userStatus,
    },
    validate,
    onSubmit: (values) => {
      if(name === values.username){
        delete values.username
      }
      const setobject = {
        ...values,
        permission: dataindicatorsDataset.map((item) => ({
          id: item.id,
          userId: item.userId,
          indicatorsDatasetSettingId: item.indicatorsDatasetSettingId,
          manageUser: item.manageUser,
          manageUserAccount: item.manageUserAccount,
          importAndCheckData: item.importAndCheckData,
          manageInformationP: item.manageInformationP,
          editUser: item.editUser,
          viewAndDownload: item.viewAndDownload,
          importData: item.importData,
          reviewAppoveCancelData: item.reviewAppoveCancelData,
          someViewAndDownload: item.someViewAndDownload,
          registerUser: item.registerUser,
        })),
      };
      const sendObject = {
        params: {
          userId: userId,
        },
        update: setobject,
      };
      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/update`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: sendObject,
      };

      axios(config)
        .then((response) => {
          showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
        })
        .catch((error) => {
          if (error.response.data.message) {
            showNotify(error.response.data.message, "error");
          } else {
            showNotify(error.message, "error");
          }
        });
    },
  });

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          userId: userId,
        },
        show: 1000,
        page: pageNumber,
        orderBy: "indicatorsDatasetSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/usersPermissionList`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataindicatorsDataset(response.data.data);
          setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [pageNumber, openModalAddPermission]);

  useEffect(() => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      params: {
        agencyId: agencyId,
        "up.upId": userId || null,
      },
      show: 54,
      page: 1,
      orderBy: "indicatorsDatasetSettingId",
      orderType: "ASC",
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/tabindicatorslist`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setIndicatorsData(response.data);
      })
      .catch(function(error) {
        console.log("setting-table/tabindicatorslist", error);
      });
  }, [agencyId]);

  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };

  const handleChange = (key, name, value) => {
    let newArr = [...dataindicatorsDataset];
    newArr[key][name] = value === 0 ? 1 : 0;

    setDataindicatorsDataset(newArr);
  };

  return (
    <>
      <Container>
        <ToastContainer />
        <MenuBar path={location} title="การจัดการข้อมูลส่วนตัว" />
        <Form onSubmit={formik.handleSubmit}>
          <UserProfilePage>
            <h6 className="bold ">ข้อมูลการเข้าสู่ระบบ</h6>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    ชื่อผู้ใช้งาน<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    name="username"
                    placeholder="ชื่อผู้ใช้งาน"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.username}
                    value={formik.values.username}
                  />
                  {formik.errors.username && (
                    <FormFeedback>{formik.errors.username}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>ประเภทผู้ใช้งาน</label>
                  <SelectTypeUser
                    placeholder="เลือก"
                    name="userTypeId"
                    onChange={(e) => {
                      setUserTypeId(
                        e.target.value === "0" ? "" : e.target.value
                      );
                    }}
                    defaultValue={userTypeId}
                    value={userTypeId}
                    invalid={!!formik.errors.userType}
                    disabled={
                      curruntUser != null && curruntUser.detail.userType != 1
                    }
                  />
                  {formik.errors.userType && (
                    <FormFeedback>{formik.errors.userType}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup className="mt-2">
                  <label>สถานะผู้ใช้งาน</label>
                  <FormCheckbox
                    toggle
                    checked={userStatus === 2 ? true : false}
                    onChange={(e) => setUserStatus(userStatus === 2 ? 1 : 2)}
                  >
                    {userStatus === 2 ? "เปิด" : "ปิด"}
                  </FormCheckbox>
                </FormGroup>
              </Col>
            </Row>
            {/* <h6 className="bold mt-4">ข้อมูลรหัสผ่าน</h6>
              {changePassword ? (
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <label>
                        รหัสผ่านเดิม<span className="color-red">*</span>
                      </label>
                      <FormInput
                        type="password"
                        name="oldPassword"
                        placeholder="รหัสผ่านเดิม"
                        onChange={formik.handleChange}
                        invalid={!!formik.errors.oldPassword}
                        value={formik.values.oldPassword}
                      />
                      {formik.errors.oldPassword && (
                        <FormFeedback>{formik.errors.oldPassword}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label>
                        รหัสใหม่<span className="color-red">*</span>
                      </label>
                      <FormInput
                        type="password"
                        name="password"
                        placeholder="รหัสใหม่"
                        onChange={formik.handleChange}
                        invalid={!!formik.errors.password}
                        value={formik.values.password}
                      />
                      {formik.errors.password && (
                        <FormFeedback>{formik.errors.password}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label>
                        ยินยันรหัสใหม่อีกครั้ง
                        <span className="color-red">*</span>
                      </label>
                      <FormInput
                        type="password"
                        name="confirmpassword"
                        placeholder="ยินยันรหัสใหม่อีกครั้ง"
                        onChange={formik.handleChange}
                        invalid={!!formik.errors.confirmpassword}
                        value={formik.values.confirmpassword}
                      />
                      {formik.errors.confirmpassword && (
                        <FormFeedback>
                          {formik.errors.confirmpassword}
                        </FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              ) : (
                <Link
                  className="mb-5 mt-5"
                  color="#1968BC"
                  onClick={() => setChangePassword(true)}
                >
                  เปลี่ยนรหัสผ่าน
                </Link>
              )} */}

            <h6 className="bold  mt-4">ข้อมูลส่วนตัว</h6>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    ชื่อ<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    placeholder="ชื่อ"
                    name="firstName"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.firstName}
                    value={formik.values.firstName}
                  />
                  {formik.errors.firstName && (
                    <FormFeedback>{formik.errors.firstName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>
                    นามสกุล<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    placeholder="นามสกุล"
                    name="lastName"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.lastName}
                    value={formik.values.lastName}
                  />
                  {formik.errors.lastName && (
                    <FormFeedback>{formik.errors.lastName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>
                    เบอร์ติดต่อ<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="tel"
                    name="phone"
                    placeholder="เบอร์ติดต่อ"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.phone}
                    value={formik.values.phone}
                  />
                  {formik.errors.phone && (
                    <FormFeedback>{formik.errors.phone}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    อีเมล<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="email"
                    name="email"
                    placeholder="อีเมล"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.email}
                    value={formik.values.email}
                  />
                  {formik.errors.email && (
                    <FormFeedback>{formik.errors.email}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    ประเภทหน่วยงานของท่าน<span className="color-red">*</span>
                  </label>
                  <SelectagencyType
                    placeholder="เลือก"
                    name="agencyTypeId"
                    onChange={(e) => {
                      const id = e.nativeEvent.target.selectedIndex;
                      if (id !== "1" && id !== "0" && id !== 1 && id !== 0) {
                        setAgencyId("32");
                      }
                      setAgencyTypeId(e.target.value);
                      setAgencyName("");
                      setAgencyType(e.nativeEvent.target[id].text);

                      // formik.handleChange(e);
                    }}
                    value={formik.values.agencyTypeId}
                    invalid={!!formik.errors.agencyTypeId}
                    // onBlur={formik.handleBlur}
                  />
                  {formik.errors.agencyTypeId && (
                    <FormFeedback>{formik.errors.agencyTypeId}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>
                    ชื่อหน่วยงาน<span className="color-red">*</span>
                  </label>
                  <SelectAgency
                    placeholder="เลือก"
                    name="agencyId"
                    onChange={(e) => {
                      const id = e.nativeEvent.target.selectedIndex;
                      setAgencyId(e.target.value);
                      if (e.target.value === "32") {
                        setAgencyName("");
                      } else {
                        setAgencyName(e.nativeEvent.target[id].text);
                      }
                      // formik.handleChange(e);
                    }}
                    defaultValue={agencyId}
                    disabled={
                      agencyTypeId &&
                      agencyTypeId !== "1" &&
                      agencyTypeId !== 1 &&
                      agencyTypeId !== "0" &&
                      agencyTypeId !== 0
                    }
                    value={formik.values.agencyId}
                    invalid={!!formik.errors.agencyId}
                    typeId={formik.values.agencyTypeId}
                    // onBlur={formik.handleBlur}
                  />
                  {formik.errors.agencyId && (
                    <FormFeedback>{formik.errors.agencyId}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              {(formik.values.agencyId === "32" ||
                formik.values.agencyId === 32) && (
                <Col md="3">
                  <FormGroup>
                    <label>
                      ชื่อหน่วยงาน<span className="color-red">*</span>
                    </label>
                    <FormInput
                      type="text"
                      placeholder="โปรดระบุ"
                      onChange={formik.handleChange}
                      name="agencyName"
                      invalid={!!formik.errors.agencyName}
                      value={formik.values.agencyName}
                    />
                    {formik.errors.agencyName && (
                      <FormFeedback>{formik.errors.agencyName}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
              )}
              <Col md="3">
                <FormGroup>
                  <label>ตำแหน่ง/อาชีพ</label>
                  <FormInput
                    type="text"
                    placeholder="ตำแหน่ง"
                    onChange={formik.handleChange}
                    name="positionName"
                    invalid={!!formik.errors.positionName}
                    value={formik.values.positionName}
                  />
                  {formik.errors.positionName && (
                    <FormFeedback>{formik.errors.positionName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <label>จุดประสงค์ในการเข้าใช้งานระบบ</label>
                  <FormTextarea
                    name="purposeAccessingSystem"
                    onChange={formik.handleChange}
                    value={formik.values.purposeAccessingSystem}
                    invalid={!!formik.errors.purposeAccessingSystem}
                    placeholder="จุดประสงค์ในการเข้าใช้งานระบบ"
                  />

                  {formik.errors.purposeAccessingSystem && (
                    <FormFeedback>
                      {formik.errors.purposeAccessingSystem}
                    </FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>

            {userTypeId == 3 || userTypeId == 4 ? (
              <>
                <hr />
                {console.log("indicatorsData", indicatorsData)}
                <Row>
                  <Col md="8">
                    <h6 className="bold">สิทธ์ในการจัดการชุดข้อมูล</h6>
                    <div className="bold">
                      ** หากไม่เลือกจะได้สิทธ์ ตามหน่วยงานที่สังกัด
                    </div>
                  </Col>
                  <Col md="4">
                    <Button
                      className="btn btn-success pull-right"
                      style={{ marginBottom: "10px" }}
                      type="button"
                      onClick={() => setOpenModalAddPermission(true)}
                      // href={`/administrator/users/create`}
                    >
                      + เพิ่มสิทธิการเข้าถึงข้อมูล/ตัวชี้วัด
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <table className="table mb-0">
                      <thead className="thead-dark">
                        <tr>
                          <th className="mw200" scope="col">
                            รายการข้อมูล/ตัวชี้วัด
                          </th>
                          <th className="mw160" scope="col">
                            นำเข้าข้อมูล
                          </th>
                          <th className="mw100" scope="col">
                            ตรวจสอบและอนุมัติ
                          </th>
                          <th className="mw100" scope="col">
                            ลบข้อมูล
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-middle">
                        {dataindicatorsDataset != null &&
                        dataindicatorsDataset.length > 0 ? (
                          dataindicatorsDataset.map((item, key) => (
                            <tr key={key}>
                              <td>
                                {item.indicatorsDatasetSettingId} :{" "}
                                {item.indicatorsDatasetSettingName}
                              </td>
                              <td>
                                <FormCheckbox
                                  toggle
                                  checked={item.importData == 1 ? true : false}
                                  onChange={() =>
                                    handleChange(
                                      key,
                                      "importData",
                                      item.importData
                                    )
                                  }
                                ></FormCheckbox>
                              </td>
                              <td>
                                <FormCheckbox
                                  toggle
                                  checked={
                                    item.importAndCheckData == 1 ? true : false
                                  }
                                  onChange={() => {
                                    handleChange(
                                      key,
                                      "importAndCheckData",
                                      item.importAndCheckData
                                    );

                                    if (item.importAndCheckData == 1) {
                                      console.log(item.importAndCheckData);
                                      handleChange(key, "importData", 0);
                                    }
                                  }}
                                ></FormCheckbox>
                              </td>
                              <td>
                                <FormCheckbox
                                  toggle
                                  checked={
                                    item.reviewAppoveCancelData == 1
                                      ? true
                                      : false
                                  }
                                  onChange={() => {
                                    handleChange(
                                      key,
                                      "reviewAppoveCancelData",
                                      item.reviewAppoveCancelData
                                    );
                                  }}
                                ></FormCheckbox>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5}>ยังไม่มีรายการข้อมูล/ตัวชี้วัด</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Col>
                  {/* <Col md="12" style={{ textAlign: "right" }}>
                {dataindicatorsDataset != null && (
                  <ReactPaginate
                    pageCount={totalPage}
                    forcePage={pageNumber - 1}
                    containerClassName="pagination"
                    nextLabel=">"
                    previousLabel="<"
                    onPageChange={({ selected }) => {
                      nextPage(selected, totalPage);
                    }}
                  />
                )}
              </Col> */}
                </Row>
              </>
            ) : null}
          </UserProfilePage>
          <UserProfileFooter>
            <Row>
              <Col md="6"></Col>
              <Col md="3">
                <Button
                  className="btn btn-white w-100"
                  onClick={() => (window.location = "/administrator/users")}
                >
                  {"< กลับ"}
                </Button>
              </Col>
              <Col md="3">
                <Button type="submit" className="btn btn-success w-100">
                  บันทึกข้อมูล
                </Button>
              </Col>
            </Row>
          </UserProfileFooter>
        </Form>
      </Container>

      {openModalAddPermission && (
        <ModalAddPermission
          open={openModalAddPermission}
          toggle={() => setOpenModalAddPermission(false)}
          userId={userId}
          selectData={
            dataindicatorsDataset.length > 0
              ? dataindicatorsDataset.map(
                  (item) => item.indicatorsDatasetSettingId
                )
              : []
          }
        />
      )}
    </>
  );
};

export default AdminUserDetail;
